/* Albatross x Hemisphere — Collapsible content accordion */
(() => {
  if (customElements.get('hm-accordion')) return;

  class HmAccordion extends HTMLElement {
    connectedCallback() {
      if (!this._clickBound) {
        this._clickBound = true;
        this.addEventListener('click', (event) => {
          const toggle = event.target.closest('.hm-cc__toggle');
          if (!toggle || !this.contains(toggle)) return;
          this.setOpen(toggle.closest('.hm-cc__row'), toggle.getAttribute('aria-expanded') !== 'true');
        });
      }
      // Theme editor: open the row whose block is selected, restore afterwards
      this._onSelect = (event) => {
        const row = this.querySelector(`.hm-cc__row[data-block-id="${event.detail.blockId}"]`);
        if (!row) return;
        row.dataset.wasOpen = row.classList.contains('is-open');
        this.setOpen(row, true);
      };
      this._onDeselect = (event) => {
        const row = this.querySelector(`.hm-cc__row[data-block-id="${event.detail.blockId}"]`);
        if (row && row.dataset.wasOpen === 'false') this.setOpen(row, false);
      };
      document.addEventListener('shopify:block:select', this._onSelect);
      document.addEventListener('shopify:block:deselect', this._onDeselect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this._onSelect);
      document.removeEventListener('shopify:block:deselect', this._onDeselect);
    }

    setOpen(row, open) {
      if (!row) return;
      const toggle = row.querySelector('.hm-cc__toggle');
      row.classList.toggle('is-open', open);
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  }

  customElements.define('hm-accordion', HmAccordion);
})();
